import React from "react";

const UserIconSVG: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      width="40"
      height="40"
    
      
      {...props}
    >
      {/* Outer Circle (Background) */}
      <circle cx="32" cy="32" r="32" fill="#C1C9F9" />

      {/* Head */}
      <circle cx="32" cy="22" r="10" fill="#FFFFFF" />

      {/* Body */}
      <path
        d="M20,44c0-6.627,5.373-12,12-12s12,5.373,12,12v8H20v-8z"
        fill="#FFFFFF"
      />
      
      {/* Shoulders */}
      <path
        d="M16,48c0-8.837,7.163-16,16-16s16,7.163,16,16"
        fill="#FFFFFF"
        opacity="0.5"
      />
    </svg>
  );
};

export default UserIconSVG;
